import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import ApiFactory from 'Api/ApiFactory';
import { GetUserHierarchyDetailsRequest, IUserHierarchyViewModel, UserHierarchyViewModel } from 'Api/CoreApi';

import Multiselect from 'vue-multiselect';
import ModalEventBus, { IModal } from 'Events/ModalEventBus';

import DeliveryAddressModalComponent from "Components/Ecom/Checkout/Shipping/DeliveryAddressModalComponent";
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { mixins } from 'vue-class-component';


export interface ISelectModel{
    id: string;
    name: string;
    obj: IDeliveryAddressViewModel;
    $isDisabled: boolean;
    canDelete: boolean;
}


export interface IDeliveryAddressViewModel {
    text: string;
    value: string;
    description: string;
    id: string;
    name: string;
    address: string;
    address2: string;
    postalCode: string;
    postalCity: string;
    company: string;
    countryCode: string;
    countryName: string;
    canSave: boolean;
}

interface IDeliveryCountry {
    code: string;
    name: string;
}


@Component({
    template: '#delivery-address-template',
    components: {
        DeliveryAddressModalComponent,
        Multiselect
    }
    //name: 'delivery-address'
})
export default class DeliveryAddressComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    @Prop()
    private selectedDeliveryAddressTmp: IDeliveryAddressViewModel;
    @Prop()
    private selectedDeliveryAddressId: string;
    @Prop()
    private deliveryAddresses: Array<IDeliveryAddressViewModel>;
    
    //we needs to store the data to a data property to avoid mutations which is not allowed for props
    private options: ISelectModel[] = [];
    
    //selected option
    public selected: ISelectModel = <ISelectModel>{};
    
    //tmp to hold data about user hierarchy
    availableHierarchyUsers: { [key: string]: UserHierarchyViewModel[]; } = null;
    
    
    private selectedDeleteOption : ISelectModel;
    
    async created() {
        //ONLY load for admins (NOT c customers)
        if(this.isABCustomer && this.isAdmin){
            const client = await ApiFactory.getOrderingListUserHierarchyClient();
            const response = await client.getHierarchy(new GetUserHierarchyDetailsRequest());
            this.availableHierarchyUsers = response.list;
        }
        
        this.options = this.buildOptions();
        
        if (this.selectedDeliveryAddressId != null && this.selectedDeliveryAddressId.length) {
            this.setSelected(this.options.find(x => x.id === this.selectedDeliveryAddressId));
        } else if (this.selectedDeliveryAddressTmp != null) {
            //emit save changes from order to fields.
            const selectedOption = this.options.find(x => x.id === this.selectedDeliveryAddressTmp.id);
            if(selectedOption){
                this.setSelected(selectedOption);
            }else{
                this.$emit('update-delivery-address', this.selectedDeliveryAddressTmp);
            }
            
        }
    }
    
    async mounted() {
        
        
    }
    
    getOptions() : ISelectModel[] {
        return this.options;
    }
    
    
    buildOptions() : ISelectModel[] {
        const list = new Array<ISelectModel>();
        if(this.deliveryAddresses != null && this.deliveryAddresses.length > 0){
            list.push(<ISelectModel>{
                $isDisabled: true,
                id: 'standardDeliveryScope',
                obj: null
            });
            
            const deliveryAddress = this.deliveryAddresses.map((x) => {
                
                const obj = <ISelectModel> {
                    id: x.id,
                    name: x.name,
                    $isDisabled: false,
                    obj : x,
                    canDelete: true //TODO: - what is the address is the standard address ? -..
                };
                
                list.push(obj);
                return obj;
            });
            
            list.concat(deliveryAddress);
        }
        
        
        
        if(this.availableHierarchyUsers){
            {
                const sortedKeys = new Array<UserHierarchyViewModel>();
                
                for(let key in this.availableHierarchyUsers)
                {
                    const value = this.availableHierarchyUsers[key];
                    const parentObj = value[0].parent;
                    
                    sortedKeys.push(parentObj);
                }
                
                sortedKeys.sort((a:UserHierarchyViewModel,b:UserHierarchyViewModel) => {
                    if(a.companyName > b.companyName) return 1
                    if(b.companyName > a.companyName) return -1 
                    return 0;
                });
                
                
                sortedKeys.forEach((parentObj: UserHierarchyViewModel, index: number) => {
                    const value = this.availableHierarchyUsers[parentObj.customerNumber];
                    
                    var parentSelectModel = this.convertUserHierarchyToSelectModel(parentObj);
                    parentSelectModel.$isDisabled = true;
                    list.push(parentSelectModel);
                    
                    value.sort((a:UserHierarchyViewModel,b:UserHierarchyViewModel) => {
                        if(a.companyName > b.companyName) return 1
                        if(b.companyName > a.companyName) return -1 
                        return 0;
                    });
                    
                    for(let child of value)
                    {
                        var childSelectModel = this.convertUserHierarchyToSelectModel(child)
                        list.push(childSelectModel);
                    }
                });
            }
        }
        return list;
    }
    
    getOptionLabel(option: ISelectModel): string {
        if(option == null) return '';
        if(option.$isDisabled && option.obj == null){
            return `${option.name}`;
        }
        
        if(option.obj == null) return;
        
        return `${option.obj.company}${option.obj.company.length ? ',' : ''} 
        ${option.obj.description}${option.obj.description.length ? ',' : ''}
        ${option.obj.address}, ${option.obj.postalCode}, ${option.obj.postalCity}`
        .replace(/(\r\n|\n|\r)/gm, ""); //remove new line
    }
    
    setSelected(value: ISelectModel) {
        //  trigger a mutation, or dispatch an action
        this.selected = value;
        
        if(value == null ||value.obj == null) return;
        this.selected.obj.canSave = this.selected.canDelete;
        this.$emit('update-delivery-address', this.selected.obj);
    }
    
    showModal(option: ISelectModel) {
        
        this.selectedDeleteOption = option;
        
        const self = this;
        const obj: IModal = <any>{
            header: option.name,
            message:  this.getOptionLabel(option),
            success: async (payload: any) =>  { //callback on accept from user
                self.deleteDeliveryAddress(self.selectedDeleteOption.obj);
                self.options = self.options.filter((element) => { return element.id !== self.selectedDeleteOption.id });
                //IMPORTANT - override select delete option
                this.selectedDeleteOption = null;
            }, 
            close: async(e: any) => {
                this.selectedDeleteOption = null;
            }
            //TODO: what about cancel
            
        };
        
        //option modal
        ModalEventBus.$emit('component-wrapper-add', {type: 'deliveryaddress-modal-component' });
        //it is better safe to wait till the component is initialized and mounted!
        setTimeout(() => {
            ModalEventBus.$emit('show-modal', obj);
        },100);
    }
    
    test(){
        
    }
    
    deselect(){
        this.selected = <ISelectModel>{};
        this.$emit('update-delivery-address', {});
        console.log('deselect:');
    }
    
    
    showDeleteBtn(option: ISelectModel)    {
        if(!option.canDelete) return false;
        return !option.$isDisabled;
    }
    
    //delete deliveryAddress 
    async deleteDeliveryAddress(obj: IDeliveryAddressViewModel) {
        
        if(obj == null || obj.id == null) return; //DO NOTHING
        return await ApiFactory.deleteAddress(obj.id);
    }
    
    
    
    convertUserHierarchyToSelectModel(user: UserHierarchyViewModel){
        var deliveryObj = <IDeliveryAddressViewModel>{
            address: user.customerAddress,
            address2: user.customerAddress2,
            company: user.companyName,
            countryCode: user.countryCode,
            countryName: user.countryCode,
            description: '',
            id: user.customerNumber,
            name: user.companyName,
            postalCity: user.postalCity,
            postalCode: user.postalCode,
            text:'',
            value: 'AAL',
        };
        
        
        var selectModel = <ISelectModel>{
            $isDisabled: false,
            id: deliveryObj.id,
            name: deliveryObj.name,
            obj: deliveryObj,
            canDelete: false
        };
        
        return selectModel;
    }
}

Vue.component('delivery-address', DeliveryAddressComponent);


